import { render, staticRenderFns } from "./OrderPaper.vue?vue&type=template&id=0f77e56b&scoped=true&"
import script from "./OrderPaper.vue?vue&type=script&lang=js&"
export * from "./OrderPaper.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaper.vue?vue&type=style&index=0&id=0f77e56b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77e56b",
  null
  
)

export default component.exports